import {useEffect, useState} from "react";
import {getCurrentTimeHM} from "@src/utils/formatDate.ts";


export const Clock = () => {
    const [time, setTime] = useState(getCurrentTimeHM)

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(getCurrentTimeHM())
        }, 1000) // обновляем каждую секунду

        return () => clearInterval(interval) // очистка таймера при размонтировании
    }, [])

    return time
}